import CVProfileInformation from "../../../../../components/CVprofileInformation";
import "./profileinformation.css"
const CVInformation = ({cvdata}) => {
    return (
        <div>
            <CVProfileInformation header="cv-header-4 " title="title-margin-4" desc="desc-margin-4" cvdata={cvdata}/>
        </div>
    )
}
export default CVInformation;